import { defineMessages, useIntl } from 'react-intl';

import type { IMenuLink } from '@components/MobileSideMenu/MobileSideMenu';

import * as ROUTES from '@constants/routes';

import { useFeatureFlags } from '@hooks/useFeatureFlags';

const messages = defineMessages({
  legal: {
    id: 'mobileSideMenu.legal',
    defaultMessage: 'Legal/Directives',
  },
  insurance: {
    id: 'mobileSideMenu.insurance',
    defaultMessage: 'Insurance',
  },
  devices: {
    id: 'mobileSideMenu.devices',
    defaultMessage: 'Health Devices',
  },
  emergencyAccess: {
    id: 'mobileSideMenu.emergencyAccess',
    defaultMessage: 'Emergency Access',
  },
  contacts: {
    id: 'mobileSideMenu.contacts',
    defaultMessage: 'Contacts',
  },
  uploads: {
    id: 'moreDrawer.uploads',
    defaultMessage: 'Records/Documents',
  },
  connections: {
    id: 'moreDrawer.connections',
    defaultMessage: 'Hospital/Clinic Connections',
  },
  shareHistory: {
    id: 'moreDrawer.shareHistory',
    defaultMessage: 'Share History',
  },
  assessments: {
    id: 'moreDrawer.assessments',
    defaultMessage: 'Assessments',
  },
});
function useMenuLinks() {
  const { flags } = useFeatureFlags();
  const { formatMessage } = useIntl();

  const patientLinks: IMenuLink[] = [
    {
      iconName: 'watch-fitness',
      route: ROUTES.DEVICES,
      label: formatMessage(messages.devices),
    },
    {
      iconName: 'address-card',
      route: ROUTES.INSURANCE,
      label: formatMessage(messages.insurance),
    },
    {
      iconName: 'gavel',
      route: ROUTES.LEGAL,
      label: formatMessage(messages.legal),
    },
    {
      iconName: 'display-medical',
      route: ROUTES.EMERGENCY_ACCESS_SETTINGS,
      label: formatMessage(messages.emergencyAccess),
    },
    {
      iconName: 'files',
      route: ROUTES.UPLOADS,
      label: formatMessage(messages.uploads),
    },
    {
      iconName: 'hospital',
      route: ROUTES.HOSPITAL_CONNECTIONS,
      label: formatMessage(messages.connections),
    },
    {
      iconName: 'share-nodes',
      route: ROUTES.SHARE_HISTORY,
      label: formatMessage(messages.shareHistory),
    },

    {
      iconName: 'magnifying-glass-chart',
      route: ROUTES.ASSESSMENTS,
      label: formatMessage(messages.assessments),
      show: flags.isAssessmentListAssessmentsEnabled,
    },
  ];

  return { patientLinks };
}

export default useMenuLinks;
